<template>
  <div class="profile-settings text-center">
    <TopMenu
      :title="$t('PROFILE.CALENDAR.PAGE_LABEL')"
      back-to="/dashboard/profile"
      dark-background/>
    <div class="container-fluid content">
      <form
        class="form-profile-settings m-2"
        @submit.prevent="save">
        <div class="row-item-transparent-with-border mt-3 mb-4 text-left">
          <h3>{{ $t('PROFILE.CALENDAR.HEADER') }}</h3>
        </div>
        <FormCheckbox
          v-for="(settings, index) in localCalendarPreferences"
          :key="index"
          v-model="settings.value"
          :prepend="$t('PROFILE.CALENDAR.' + settings.name)"
          class="row-item-transparent mb-1" />
        <ActionButton
          type="submit"
          class="btn btn-lg btn-primary btn-block mt-3 mb-3">{{ $t("PROFILE.CALENDAR.SAVE_BUTTON") }}</ActionButton>
      </form>
    </div>
    <BottomMenu />
  </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import { mapState } from 'vuex';
import TopMenu from '@/components/Menu/TopMenu';
import BottomMenu from '@/components/Menu/BottomMenu';
import ActionButton from '@/components/Actions/ActionButton';
import FormCheckbox from '@/components/Forms/FormCheckbox';

export default {
  name: 'ProfileCalendar',
  components: {
    ActionButton,
    TopMenu,
    BottomMenu,
    FormCheckbox,
  },
  data() {
    return {
      localCalendarPreferences: [],
    };
  },
  computed: {
    ...mapState('member', ['selectedCalendarPreferences']),
  },
  watch: {
    selectedCalendarPreferences: {
      handler(newVal) {
        if (newVal) {
          this.localCalendarPreferences = cloneDeep(newVal);
        } else {
          this.localCalendarPreferences = [];
        }
      },
      immediate: true,
    },
  },
  created() {
    this.$store.dispatch('member/currentMemberCalendarPreferences');
  },
  methods: {
    save() {
      this.$store
        .dispatch(
          'member/saveCalendarPreferences',
          this.localCalendarPreferences,
        )
        .then(() => {
          this.$store.commit('alerts/setAlert', {
            msg: 'PROFILE.CALENDAR.CONFIRMATION_MESSAGE',
          });
        });
    },
  },
};
</script>

<style scoped lang="scss">
div {
  &.profile-settings {
    height: 100%;
  }
  &.content {
    padding-top: $top-menu-height;
    padding-bottom: $bottom-menu-height;
    background-color: $base;
    min-height: 100%;
  }
}
</style>
